<template>
  <div class="full-page">
    <div class="header"></div>
    <div class="content">
      <div class="left">
        <img src="./image/content1.png" alt="" />
      </div>
      <div class="center">
        <img class="title-img" src="./image/content2.png" alt="" />
        <img class="middle-img" src="./image/content4.png" alt="" />
        <img class="manager-img" src="./image/title.png" alt="" />
        <div class="phoneinfo">
          <div class="firstinfo" v-for="(item, index) in contractUserList" :key="index">
            <span>{{ item.userName }}</span>
            <span>{{ item.mobile }}</span>
          </div>
        </div>
        <div class="bottom-content">
          <img class="register-btn" src="./image/btn4.gif" alt="" @click="registerForGuidance" />
          <p class="store-count">您区域内已有{{ storeCount }} 家入驻</p>
        </div>
      </div>
      <div class="right">
        <img src="./image/code2.png" alt="" />
      </div>
    </div>
    <div class="footer"></div>
    <el-dialog
      custom-class="supplement-dialog"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="true"
      title="请留下您的联系方式"
      alignFooter="center"
      width="30%"
      center
    >
      <div class="supplement-box">
        <div class="content-form">
          <el-form ref="form" :model="form" label-width="auto">
            <el-form-item>
              <el-input
                v-model="form.phone"
                oninput="value=value.replace(/[^\d]/g,'')"
                placeholder="请输入您的电话号码"
                number
                maxlength="11"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">提 交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import activityApi from '@/api/activity';
import throttle from 'lodash/throttle';
export default {
  name: 'test',
  data() {
    return {
      storeCount: 5,
      protocol: window.location.protocol,
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: ['blur', 'change'] },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的11位手机号', trigger: ['blur', 'change'] }
        ]
      },
      guideAction: '',
      contractUserList: [
        { userName: '', mobile: '' },
        { userName: '', mobile: '' }
      ],
      dialogFormVisible: false,
      form: {
        phone: ''
      }
    };
  },
  created() {
    this.getGuideRoute();
  },

  methods: {
    onSubmit: throttle(async function() {
      if (!this.form.phone) {
        this.protocolShow = true;
        this.$message('请输入正确的手机号码');
        return;
      } else if (!/^1[3456789]\d{9}$/.test(this.form.phone)) {
        this.protocolShow = true;
        this.$message('请输入正确的手机号码');
        return;
      }
      const params = {
        phone: this.form.phone
      };
      try {
        const res = await activityApi.registerForGuidance(params);
        if (res) {
          this.dialogFormVisible = false;
          this.$message({
            message: '药开开业务经理将在一个工作日内与您取得联系',
            type: 'success'
          });
        }
      } catch (error) {}
    }, 800),
    registerForGuidance() {
      this.form.phone = '';
      this.dialogFormVisible = true;
    },
    async getGuideRoute() {
      const res = await activityApi.getGuideRoute();
      this.contractUserList = res.contractUserList || '';
      this.storeCount = res.openCount;
    }
  }
};
</script>

<style lang="scss" scoped>
.full-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  /deep/ .yao-modal div.el-dialog__header,
  /deep/ .yao-modal div.el-dialog__body,
  /deep/ .supplement-dialog div.el-dialog__header,
  /deep/ .supplement-dialog div.el-dialog__body {
    padding: 24px 40px;
  }
  /deep/.el-dialog__headerbtn {
    display: block !important;
  }
  /deep/.el-dialog__headerbtn {
    /deep/.el-dialog__close:hover {
      color: #3474d3 !important;
    }
  }
  .supplement-box {
    .content-form {
      /deep/.el-input__inner:focus {
        border-color: #3474d3;
      }
      /deep/ .el-input__inner {
        height: 44px;
        line-height: 44px;
        background: #f7f7f7;
      }
      /deep/ .el-form-item__content {
        display: flex;
        justify-content: space-between;
        /deep/.el-button {
          background: #3474d3;
          margin-top: 36px;
          width: 121px;
        }
      }
      /deep/ .el-form-item {
        margin-bottom: 0px;
      }
    }
  }
  .dialog-content {
    position: relative;
    height: 486px;
    border-radius: 10px;
    .close-icon {
      position: absolute;
      top: 10px;
      right: 20px;
      width: 17px;
      height: 17px;
    }
    .link-btn {
      z-index: 100;
      position: absolute;
      left: 117px;
      text-align: center;
      margin-top: 10px;
    }
    .bottom-img {
      z-index: 9;
      position: absolute;
      bottom: 0;
      width: 100%;
    }
    .mobile-box {
      position: relative;
      .mobile {
        position: absolute;
        top: 10px;
        left: 100px;
        font-size: 14px;
        font-family: '微软雅黑';
      }
    }
  }
  .content {
    display: flex;
    width: 100vw;
    height: 36.4584vw;
    justify-content: center;
    background: url('./image/bg.png') no-repeat;
    background-size: contain;
    background-color: #a3c8ff;
    .left {
      position: relative;
      width: 22.343vw;
      height: 100%;
      margin-right: 1.25vw;
      > img {
        position: absolute;
        left: 0;
        bottom: 2.448vw;
        width: 100%;
        height: auto;
      }
    }
    .center {
      width: 30.8854vw;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      > .title-img {
        width: 30.8854vw;
        height: auto;
      }
      > .middle-img {
        width: 100%;
        height: auto;
      }
      > .manager-img {
        width: 8.8021vw;
        height: auto;
        margin: 0.7291vw auto 0.9895vw;
      }
      > .phoneinfo {
        display: flex;
        height: 1.5625vw;
        padding: 0 5.5208vw;
        margin-bottom: 1.66667vw;
        .firstinfo {
          margin-right: 10.8333vw;
          position: relative;
          color: #294a7b;
          font-size: 0.52083vw !important;
          font-weight: 700;
          span {
            position: absolute;
            top: 0.27058vw;
            left: 0.36458vw;
            line-height: 1.5625vw;
          }
          :nth-child(1) {
            display: block;
            width: 3.3854vw;
            height: 1.5625vw;
            background: url('./image/rectangle.png') no-repeat;
            background-size: 100% 100%;
            // padding: 0 0.2625vw;
            text-align: center;
          }
          :nth-child(2) {
            margin-left: 3.5333vw;
          }
          > img {
            width: 3.38542vw;
            height: 1.5625vw;
          }
        }
        > .backgimg {
          z-index: 99;
          width: 100%;
        }
        .backgimg1 {
          position: absolute;
          left: 13.4548vw;
        }
      }
      .bottom-content {
        width: 100%;
        text-align: center;
        margin-bottom: 2.0833vw;
        > img {
          width: 100%;
          height: auto;
        }
        .agreement-box {
          position: relative;
          margin: 0 auto;
          .tip {
            position: absolute;
            top: -2.125vw;
            left: 50%;
            transform: translateX(-50%);
            padding: 0 5px;
            height: 2.1671vw;
            margin-left: -1.125vw;
            line-height: 2.1671vw;
            white-space: nowrap;
            letter-spacing: 0;
            font-size: 0.72916vw;
            color: #fff;
            background: url('./image/btn2.png') no-repeat;
            background-size: 100% 100%;
          }
          .agreement-content {
            margin-top: 0.26042vw;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 14px;
              height: 14px;
              margin-right: 0.26042vw;
            }
            .protocol-name {
              color: #1f3e85;
              cursor: pointer;
            }
          }
        }
        .register-btn {
          cursor: pointer;
          width: 19.166667vw;
        }
        .store-count {
          margin: 0 auto;
          width: 13.8542vw;
          height: 1.77083vw;
          line-height: 1.77083vw;
          font-size: 0.72917vw;
          color: #fff;
          background: url('./image/btn1.png') no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .right {
      display: flex;
      position: relative;
      width: 26.51vw;
      height: 100%;
      > img {
        position: absolute;
        left: 0vw;
        bottom: 2.08333vw;
        width: 18.1771vw;
        height: auto;
        top: 1.92708vw;
      }
    }
  }
  .header {
    width: 100vw;
    height: calc((100vh - 36.4584vw) / 2);
    background-color: #afcfff;
  }
  .footer {
    width: 100vw;
    height: calc((100vh - 36.4584vw) / 2);
    background-color: #a3c8ff;
  }
}
</style>
